module.exports = __webpack_public_path__ + "static/media/Admin-12.773d823b.png";